import type { FaireProductEntity } from "../../entity_types/product";

export const p_nyu8d5qngr: FaireProductEntity = {
  token: "p_nyu8d5qngr",
  type: "product",
  name: "Retro Arkansas Sweatshirt",
  brandToken: "b_myqj9vpqyk",
  brandName: "JAR Co",
  imageUrl:
    "https://cdn.faire.com/fastly/aaf48a464e280a59219e31eeb68ab02c0cffd1f0ffd3f67af19a0ed87a368b02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/46e38204daf1d077b8d042bc7f4706bcc4acc15410374c872bd62dc8613ca47c.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "\nWhat better way to represent your favorite state than with this SOFT and fun sweatshirt? This retro vibe + the red, black, and white colors could not be anymore perfect! \n\n\n * Gildan \n * 50/50 Cotton/Polyester \n * Unisex: True to Size Fit \n\n**Some may be substituted with Port and Co as needed. 4XL WILL be Port and Co** \n\nModel is wearing a size Medium for an oversized fit. Her true size is Small. \n",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T22:14:31.731Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
